import { useEffect, useRef, FC } from 'react';
import { Box } from "@chakra-ui/react"
import { usePack, usePackAssets, useToastNotification, useUploadFiles } from "lib/hooks";
import { useProgressContext } from 'lib/context/progressContext';
import { isReadOnly } from "lib/utils";
import { usePackContext } from "domains/pack";

enum Events {
  dragenter = 'dragenter',
  dragleave = 'dragleave',
  dragover = 'dragover',
  drop = 'drop',
}

// TODO: Move to utils
const addEventListeners = (events: Events[], node: HTMLElement, cb: (e?: Event) => void) => {
  events.forEach((event) => {
    node.addEventListener(event, cb, false);
  })
}

// TODO: Move to utils
const removeEventListeners = (events: Events[], node: HTMLElement, cb: (e?: Event) => void) => {
  events.forEach((event) => {
    node.removeEventListener(event, cb, false);
  })
}

export const DropFileCatchAll: FC = ({ children }) => {
  const ref = useRef(null);
  const { packId } = usePackContext();

  const { data: pack } = usePack(packId);
  const { data } = usePackAssets(pack);
  const { uploadFiles, percent } = useUploadFiles(packId);

  const { errorToast } = useToastNotification();
  const { setProgress } = useProgressContext();

  useEffect(() => {
    setProgress(percent);
  }, [setProgress, percent]);

  useEffect(() => {
    if (!ref.current) return;

    const node = ref.current;

    const onDragEnter = (event): void => {
      event.preventDefault();
    }

    const onDrop = async (event: DragEvent): Promise<void> => {
      event.preventDefault();

      await uploadFiles(event.dataTransfer.files);
    }

    addEventListeners([Events.dragenter, Events.dragover], node, onDragEnter);
    addEventListeners([Events.drop], node, onDrop);

    return () => {
      removeEventListeners([Events.dragenter, Events.dragover], node, onDragEnter);
      removeEventListeners([Events.drop], node, onDrop);
    }
  }, [ref, pack, errorToast, data, uploadFiles]);

  if (isReadOnly(pack)) {
    return children as any;
  }

  return (
    <Box ref={ref}>
      { children }
    </Box>
  )
}
